import React, { ReactNode, FunctionComponent } from "react";
import { Popper } from "react-popper";
import { AnimatePresence } from "framer-motion";
import { BSMotionDiv } from "../../types";
import { PopoverElement } from "./PopoverElement";

export interface PopoverPopperProps extends Omit<BSMotionDiv, "title"> {
  placement?: "top" | "right" | "bottom" | "left";
  title?: ReactNode;
  visible?: boolean;
}

export const PopoverPopper: FunctionComponent<PopoverPopperProps> = ({
  placement = "right",
  visible,
  ...popoverProps
}) => (
  <AnimatePresence>
    {visible && (
      <Popper placement={placement}>
        {(p) => (
          <PopoverElement {...popoverProps} {...p} placement={placement} />
        )}
      </Popper>
    )}
  </AnimatePresence>
);
